import { useQuery } from '@tanstack/react-query';
import { BaseQueryOpts } from '../baseTypes';
import { getProviderStripeConnectDetails } from '@uplift/api';

export const useGetProviderStripeConnectDetailsQuery = (providerId: string, opts?: BaseQueryOpts) => {
  return useQuery({
    queryKey: [ 'provider', providerId, 'stripeConnection' ],
    queryFn: async () => {
      const response = await getProviderStripeConnectDetails(providerId);

      return response.data;
    },
    retry: false,
    ...opts,
  });
};
